import type { PaymentLinkResponse, PaymentLinkListParams, PaymentLinkListResponse } from '../types';
import type { RequestFn } from '../client';

/** Retrieve and list hosted payment links. */
export class PaymentLinks {
  constructor(private readonly request: RequestFn) {}

  /**
   * Retrieve a payment link by its ID.
   *
   * @param linkId - The unique payment link ID.
   * @returns The payment link details.
   */
  async retrieve(linkId: string): Promise<PaymentLinkResponse> {
    return this.request('GET', `/payment-link/${encodeURIComponent(linkId)}`);
  }

  /**
   * List payment links, optionally filtered by status or date range.
   *
   * @param params - Optional filter and pagination parameters.
   * @returns Paginated list of payment links.
   */
  async list(params?: PaymentLinkListParams): Promise<PaymentLinkListResponse> {
    return this.request('POST', '/payment-link/list', { body: params });
  }

  /** Initiate (render) a payment link page. `GET /payment-link/{merchantId}/{paymentId}` */
  async initiate(merchantId: string, paymentId: string): Promise<Record<string, unknown>> {
    return this.request(
      'GET',
      `/payment-link/${encodeURIComponent(merchantId)}/${encodeURIComponent(paymentId)}`,
    );
  }

  /** Get payment link status. `GET /payment-link/status/{merchantId}/{paymentId}` */
  async status(merchantId: string, paymentId: string): Promise<Record<string, unknown>> {
    return this.request(
      'GET',
      `/payment-link/status/${encodeURIComponent(merchantId)}/${encodeURIComponent(paymentId)}`,
    );
  }
}
